import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { WeightType } from '@tradecafe/types/core'
import { sortBy } from 'lodash-es'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


@Injectable()
@AngularCopy()
export class WeightTypeApiService {
  private http = inject(HttpClient)


  @HaveAngularParams()
  list(@AngularParams() params) {
    return this.http.get<{ data: WeightType[] }>(`${apiUrl}/weight-type`, { params }).toPromise().then(({data = []}) => {
      return {
        data: sortBy(data, 'name'),
      }
    })
  }

  create(data: Partial<WeightType>) {
    return this.http.post<{ data: WeightType }>(`${apiUrl}/weight-type`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: WeightType }>(`${apiUrl}/weight-type/${id}`).toPromise()
  }

  update(id: string, data: Partial<WeightType>) {
    return this.http.put<{ data: WeightType }>(`${apiUrl}/weight-type/${id}`, data).toPromise()
  }

  delete(id: string) {
    return this.http.delete<{ data: WeightType }>(`${apiUrl}/weight-type/${id}`).toPromise()
  }
}
